import {
  Flag,
  Mountain,
  BookOpen,
  Heart,
  Trees,
  Crown,
  Sparkles,
  Music,
  LifeBuoy,
  Users,
} from 'lucide-react';
import { FortIcon } from '../components/icons/HeritageIcons';

/**
 * Category codes must match backend organization_category.code
 * and scripts/mysql_organizations_module.sql seed data.
 */
export const organizationNavCategories = [
  { code: 'gad-sanvardhan', labelKey: 'nav.organizationCategories.fortConservation', Icon: FortIcon, color: 'text-orange-600' },
  { code: 'durg-premi', labelKey: 'nav.organizationCategories.fortEnthusiastGroups', Icon: Flag, color: 'text-amber-700' },
  { code: 'trekking-groups', labelKey: 'nav.organizationCategories.trekkingGroups', Icon: Mountain, color: 'text-emerald-600' },
  { code: 'history-research', labelKey: 'nav.organizationCategories.historyResearchInstitutes', Icon: BookOpen, color: 'text-amber-800' },
  { code: 'social-organizations', labelKey: 'nav.organizationCategories.socialOrganizations', Icon: Heart, color: 'text-rose-600' },
  { code: 'environmental', labelKey: 'nav.organizationCategories.environmentalConservation', Icon: Trees, color: 'text-green-600' },
  { code: 'shivjayanti-mandals', labelKey: 'nav.organizationCategories.shivjayantiFestivalCommittees', Icon: Crown, color: 'text-orange-700' },
  { code: 'ganpati-mandals', labelKey: 'nav.organizationCategories.ganeshFestivalCommittees', Icon: Sparkles, color: 'text-amber-500' },
  { code: 'cultural', labelKey: 'nav.organizationCategories.culturalGroups', Icon: Music, color: 'text-purple-600' },
  { code: 'rescue-groups', labelKey: 'nav.organizationCategories.rescueGroups', Icon: LifeBuoy, color: 'text-blue-700' },
];

export function findOrganizationCategory(code) {
  return organizationNavCategories.find((c) => c.code === code) ?? null;
}

export function getCategoryIcon(code) {
  return findOrganizationCategory(code)?.Icon ?? Users;
}

export function getCategoryColor(code) {
  return findOrganizationCategory(code)?.color ?? 'text-amber-700';
}

/** Legacy slug → backend code redirect map */
export const legacyCategorySlugMap = {
  'fort-conservation': 'gad-sanvardhan',
  'fort-enthusiast-groups': 'durg-premi',
  'history-study-circles': 'history-research',
  'history-research-institutes': 'history-research',
  'environmental-conservation': 'environmental',
  'shivjayanti-festival-committees': 'shivjayanti-mandals',
  'ganesh-festival-committees': 'ganpati-mandals',
  'cultural-groups': 'cultural',
};

export function resolveCategoryCode(param) {
  if (!param) return null;
  if (organizationNavCategories.some((c) => c.code === param)) return param;
  return legacyCategorySlugMap[param] ?? param;
}
